import React from "react";
import {
  GET_LOCAL_STORAGE,
  LOCAL_STORAGE_KEY,
} from "../../helpers/localStorage";

function AccessTo(props) {
  const hasAccess = props.role.includes(
    GET_LOCAL_STORAGE(LOCAL_STORAGE_KEY.selectedRole)
  );

  if (hasAccess) return <>{props.children}</>;
  return <>{props?.fallBackComponent ? props?.fallBackComponent : ""} </>;
}

export default AccessTo;
